import BasicDataTable from "../../Component/BasicComponents/BasicDataTable";
import PageHeader from "../../Component/BasicComponents/HeaderBreadCrumbs";
import {useEffect, useState } from "react";
import { useGetFTPExportLogsDashBoard, useGetFTPImportLogsDashBoard, useResetFTPImport } from "./hooks/useFTP";

const DashboardFTPLogs = () => {
 

  const [searchTimeExport,setSearchTimeExport]= useState<string>('')
  const [filtersState, setFiltersState] = useState<any>({
    pageInteger: 1,
    limitInteger: 10,
    search:'',
  });



  // API
  const {mutate:resetImprt} = useResetFTPImport();
  const [searchTime,setSeachTime] =  useState<string>('');
  const [filtersStateImport, setFiltersStateImport] = useState<any>({
    pageInteger: 1,
    limitInteger: 10,
    search:'',
  });


  //import data
  const { data, isLoading:ImportLoading, isSuccess:importIsSuccess } = useGetFTPImportLogsDashBoard({
    enable: true,
    params: {
        pageInteger: filtersStateImport.pageInteger,
        limitInteger:filtersStateImport.limitInteger,
        search:searchTime
    },
  });

  useEffect(()=>{
    const delayDebounceImport = setTimeout(()=>{
      if(searchTime.trim() !== ''){
        setFiltersStateImport((prev:any)=>({
            ...prev,
            search:searchTime
        }))
      }
    },5000)
  
    const delayDebounceExport = setTimeout(()=>{
      if(searchTimeExport.trim() !== ''){
        setFiltersState((prev:any)=>({
          ...prev,
          search:searchTimeExport
        }))
      }
    },5000)
    
    return()=>{
      clearTimeout(delayDebounceImport);
      clearTimeout(delayDebounceExport);
    }

  },[searchTime,searchTimeExport])
    

  const FTPImportsData =
    (importIsSuccess &&
      !ImportLoading &&
        data?.data?.ftpImportLogs?.map((item: any) => ({
        date: item?.CreatedAt || "-",
        file: item?.FilePath || "-",
        totalrecords: item?.NoTotalRecords || 0,
        noprocessedrecords: item?.NoProcessedRecords || 0,
        status: item?.ProcessingStatus || "-",
        starttime: item?.StartTime || "-",
        lastupdateat: item?.UpdatedAt || "-",
        processed: item?.ProcessingPercent || "-",
        processingtime: item?.ProcessingTime || "-",
        eta: item?.ETA || "-",
        FtpImportLogId:item?.FtpImportLogId || 0
      }))) ||
    [];



    //  export data
  const {data:ExportData,isLoading:ExportLoading, isSuccess:ExprtSuccess} = useGetFTPExportLogsDashBoard({
      enable: true,
      params: {
          pageInteger: filtersState.pageInteger,
          limitInteger:filtersState.limitInteger,
          search:searchTimeExport
      },
    })
  const FTPExportData =(ExprtSuccess && !ExportLoading && ExportData?.data?.ftpExportLogs?.map((item: any) => ({
        file: item?.FilePath || "-",
        date: item?.CreatedAt || "-",
        status: item?.ProcessingStatus || "-",
        starttime: item?.StartTime || "",
      }))) || [];


    const handlePaginationExport =(pageNo:number)=>{
        setFiltersState((prev:any)=>({
          ...prev,
          pageInteger:pageNo
        }))
    }

     const handleonChangeRowsPerPageExport =(limit:any,pageNo:any)=>{
     setFiltersState((prev:any)=>({
       ...prev,
       pageInteger:pageNo,
       limitInteger:limit
     })) 
     }      

     const handlePaginationImport=(pageNo:number)=>{
         setFiltersStateImport((prev:any)=>({
              ...prev,
              pageInteger:pageNo
         }))
     }

const handleonChangeRowsPerPageImport =(limit:any,pageNo:any)=>{
    setFiltersStateImport((prev:any)=>({
      ...prev,
      pageInteger:pageNo,
      limitInteger:limit,
    }))
}

  const handleFTPImportReset = (row:any) => {
      const id:number = row.FtpImportLogId;  
      if(id){
           resetImprt(id);
      }
  };


  return (
    <div className="p-2">
      <PageHeader
        title="Dashboard FTP Logs"
        buttons={[
          {
            label: "Export",
            onClick: () => alert("Action 2 clicked"),
            color: "#2e8dd3",
          },
        ]}
      />
      <BasicDataTable
        Title="FTP Imports"
        data={!ImportLoading && importIsSuccess ? FTPImportsData : []}
        columns={FTPImportRequestColumns(handleFTPImportReset)}
        search={true}
        handleSearch={(e:any)=>setSeachTime(e)}
        onChangePage={(pageNo:number)=>{
           handlePaginationImport(pageNo);        
        }}
        onChangeRowsPerPage={(newPage:any,page:any)=>{
          handleonChangeRowsPerPageImport(newPage,page);
        }}
        paginationTotalRows={data?.data?.Pagination?.TotalRecords}
      />


       <BasicDataTable
        Title="FTP Export"
        data={!ExportLoading && ExprtSuccess ? FTPExportData :[]}
        columns={FtpExportColumn}
        search={true}
        handleSearch={(e:any)=>setSearchTimeExport(e)}
        onChangePage={(pageNo:number)=>{
         handlePaginationExport(pageNo)
        }}
        onChangeRowsPerPage={(newPage:any,page:any)=>{
          handleonChangeRowsPerPageExport(newPage,page);
        }}
        paginationTotalRows={ExportData?.data?.Pagination?.TotalRecords}
      /> 
    </div>
  );
};

export default DashboardFTPLogs;

const FTPImportRequestColumns = (
  handleFTPImportReset: (row: any) => void
) => [
  {
    name: "Date",
    selector: (row: { date: number | string }) => row.date,
    sortable: true,
    width:'150px',
  },
  {
    name: "File",
    selector: (row: { file: string }) => row.file,
    sortable: true,
    wrap:true,
  },
  {
    name: "Total Records",
    selector: (row: { totalrecords: string }) => row.totalrecords,
    sortable: true,
    width:'150px'
  },
  {
    name: "No Processed Records",
    selector: (row: { noprocessedrecords: string }) => row.noprocessedrecords,
    sortable: true,
    width:'200px'

  },
  {
    name: "Status",
    selector: (row: { status: string }) => row.status,
    sortable: true,
  },
  {
    name: "Start Time",
    selector: (row: { starttime: string }) => row.starttime,
    sortable: true,
    width:'150px',
    wrap:true
  },
  {
    name: "Last Updated At",
    selector: (row: { lastupdateat: string }) => row.lastupdateat,
    sortable: true,
    width:'180px',
    wrap:true
  },
  {
    name: "Processed %",
    selector: (row: { processed: string }) => row.processed,
    sortable: true,
    width:'10px',
  },
  {
    name: "Processing Time",
    selector: (row: { processingtime: string }) => row.processingtime,
    sortable: true,
    width:'18px',
  },
  {
    name: "ETA",
    selector: (row: { eta: string }) => row.eta,
    sortable: true,
  },
  {
    name: "Actions",
    cell: (row: any) => {
      const allValuesAreDash = Object.values(row).every(
        (value) => value === "-"
      );

      return allValuesAreDash ? (
        "-" // Show "-" when all values are "-"
      ) : (
        <button
          onClick={() => handleFTPImportReset(row)}
          className="btn btn-primary"
          style={{ borderRadius: "20px", padding: "5px", width: "80px" }}
          //   disabled={disableCondition(row)}
        >
          Reset
        </button>
      );
    },
  },
];

const FtpExportColumn = [
  {
    name: "File",
    selector: (row: { file: string }) => row.file,
    sortable: true,
    wrap:true
  },
  {
    name: "Date",
    selector: (row: { date: string }) => row.date,
    sortable: true,
  },

  {
    name: "Status",
    selector: (row: { status: string }) => row.status,
    sortable: true,
  },
  {
    name: "Start Time",
    selector: (row: { starttime: string }) => row.starttime,
    sortable: true,
  },
];
